"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TabDropdown = void 0;
var React = _interopRequireWildcard(require("react"));
var _react2 = require("@floating-ui/react");
var _space = require("../../../styles/variables/_space");
var _classify = require("../../../utils/classify");
var _clickAway = require("../../../utils/click-away");
var _mergeRefs = require("../../../utils/merge-refs");
var _Menu = require("../../Menu");
var _Tooltip = require("../../Tooltip");
var _Tab = require("../Tab");
var _TabDropdownModule = _interopRequireDefault(require("./TabDropdown.module.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const TabDropdown = _ref => {
  let {
    anchorPosition = 'bottom-start',
    size,
    onOptionSelect,
    props,
    elevation = 'modal',
    classNames
  } = _ref;
  const {
    x,
    y,
    refs,
    strategy,
    context
  } = (0, _react2.useFloating)({
    open: true,
    strategy: 'absolute',
    // @ts-ignore - TS2322 - Type 'string' is not assignable to type 'Placement | undefined'.
    placement: anchorPosition,
    whileElementsMounted: _react2.autoUpdate,
    middleware: [(0, _react2.shift)(), (0, _react2.flip)(), (0, _react2.offset)(parseInt(_space.spaceXXSmall))]
  });
  return /*#__PURE__*/React.createElement(_clickAway.ClickAway, null, _ref2 => {
    let {
      isOpen,
      onOpen,
      clickAway,
      boundaryRef,
      triggerRef
    } = _ref2;
    return /*#__PURE__*/React.createElement("div", {
      "data-testid": "TabDropdown",
      className: (0, _classify.classify)(_TabDropdownModule.default.tabDropdownContainer, classNames?.wrapper)
    }, /*#__PURE__*/React.createElement(_Tab.Tab, _extends({}, props?.tab, {
      size: size
      // @ts-ignore - TS2322 - Type '((node: ReferenceType | null) => void) & ((node: ReferenceType | null) => void)' is not assignable to type '{ current: HTMLElement | null | undefined; }'.
      ,
      ref: (0, _mergeRefs.mergeRefs)([refs.setReference, triggerRef]),
      onClick: e => {
        e.stopPropagation();
        onOpen();
      },
      classNames: {
        wrapper: _TabDropdownModule.default.dotTabWrapper,
        iconTextWrap: _TabDropdownModule.default.dotTextWrap
      }
    })), isOpen && props?.menu && /*#__PURE__*/React.createElement(_react2.FloatingPortal, null, /*#__PURE__*/React.createElement(_react2.FloatingFocusManager, {
      modal: false,
      context: context
      // @ts-ignore - TS2322 - Type 'MutableRefObject<ReferenceType | null> & MutableRefObject<ReferenceType | null>' is not assignable to type 'number | MutableRefObject<HTMLElement | null> | undefined'.
      ,
      initialFocus: refs.reference
    }, /*#__PURE__*/React.createElement("div", {
      // @ts-ignore - TS2322 - Type '((node: HTMLElement | null) => void) & ((node: HTMLElement | null) => void)' is not assignable to type '{ current: HTMLElement | null | undefined; }'.
      ref: (0, _mergeRefs.mergeRefs)([refs.setFloating, boundaryRef]),
      className: _TabDropdownModule.default.menuWrapper,
      style: {
        display: 'flex',
        position: strategy,
        top: y ?? _space.spaceNone,
        left: x ?? _space.spaceNone,
        '--menu-elevation': (0, _Tooltip.getElevationValue)(elevation)
      }
    }, /*#__PURE__*/React.createElement(_Menu.Menu, _extends({}, props.menu, {
      onSelect: (option, e) => {
        onOptionSelect && onOptionSelect(option, e);
        clickAway();
      },
      size: props.menu.size || size,
      onTabOut: clickAway
    }))))));
  });
};
exports.TabDropdown = TabDropdown;